export default __webpack_public_path__ + "static/media/safety.4954f214.svg";